module.exports = __webpack_public_path__ + "static/img/img-bank_zhaoH.82131554.png";